export default __webpack_public_path__ + "static/img5-ee63e78a444a005ae7337fd1c8e9f632.png";